import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import LogoSection from "../LogoSection";
import ProfileSection from "./ProfileSection";
import { IconMenu2 } from "@tabler/icons";
import { color } from "../../../utils/color";

import API from "api/axios";
import ApiRoutes from "api/endpoint";
import { UserType } from "store/constant";

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");

  const getUserProfile = useCallback(async () => {
    try {
      const { data } = await API.request({
        url: ApiRoutes.Auth.Profile.Endpoint,
        method: ApiRoutes.Auth.Profile.Method,
      });

      setName(data?.data?.name || "");
      setEmail(data?.data?.email || "");
      setType(data?.data?.type || "");
    } catch (error) {
      localStorage.clear();
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    getUserProfile();
  }, [getUserProfile]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        px: 2,
        py: 1,
      }}
    >
      {/* Logo & Drawer Toggle */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box component="span" sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}>
          <LogoSection />
        </Box>

        <ButtonBase
          sx={{
            borderRadius: "12px",
            overflow: "hidden",
            border: `1px solid ${color.bg}`,
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: color.fg,
              color: color.bg,
              "&:hover": {
                background: color.bg,
                color: color.fg,
              },
            }}
            onClick={handleLeftDrawerToggle}
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />

      {type && (
        <Typography variant="body2" sx={{ fontWeight: 600, mr: 2 }}>
          {UserType[type] || type}
        </Typography>
      )}

      <ProfileSection name={name} email={email} type={type} />
    </Box>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
